import React from 'react';
import { XPagination } from '@/components/xqxc_ui';
import { Table } from 'antd';
import PropTypes from 'prop-types';
import { tooltipStyle, tooltip, cellWidth, priceFenToYuanCell } from '@/components/TableCell';
import styles from './TableList.module.scss';
import { AccountListFields as af } from '../../types';

class TableList extends React.Component {

    _takeColumns = () => ([
        {
            title: '记录流水号',
            dataIndex: af.recordNo,
            key: af.recordNo,
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '关联单号',
            dataIndex: af.relationNo,
            key: af.relationNo,
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '收支类型',
            dataIndex: af.incomeOutTypeDesc,
            key: af.incomeOutTypeDesc,
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '变动来源',
            dataIndex: af.changeSourceDesc,
            key: af.changeSourceDesc,
            width: cellWidth.time,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '变动金额(元)',
            dataIndex: af.changeAmount,
            key: af.changeAmount,
            width: cellWidth.normal,
            align: 'center',
            render: priceFenToYuanCell
        },
        {
            title: '服务费余额(元)',
            dataIndex: af.serviceBalance,
            key: af.serviceBalance,
            width: cellWidth.normal,
            align: 'center',
            render: priceFenToYuanCell
        },
        {
            title: '备注',
            dataIndex: af.remark,
            key: af.remark,
            width: cellWidth.big,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '变动时间',
            dataIndex: af.changeTime,
            key: af.changeTime,
            width: cellWidth.time,
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        }
    ]);

    render() {
        const { paginationChange } = this.props;
        const { pageNum, pageSize, resultTotal, dataList } = this.props.renderData;
        return (
            <div className={styles.tableContainer}>
                <Table
                    rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
                    rowKey={record => record.id}
                    columns={this._takeColumns()}
                    dataSource={dataList}
                    pagination={false}
                    scroll={{ y: true }}
                />
                <XPagination
                    resultTotal={resultTotal}
                    pageSize={pageSize}
                    pageNum={pageNum}
                    onChange={paginationChange}
                />
            </div>
        );
    }
}

TableList.propTypes = {
    renderData: PropTypes.object.isRequired, // 表格数据源
    paginationChange: PropTypes.func.isRequired, // 分页操作
    actionHandle: PropTypes.func,
};

export default TableList;